import React from 'react';
import DatePicker, {registerLocale} from "react-datepicker";
import ru from 'date-fns/locale/ru';
registerLocale('ru', ru)

const SingleDate = ({startDate, setStartDate}) => {

    return (
        <div className={'flex justify-center m-auto mt-10 overflow-clip'}>
            <div className={'inline-block relative'}>
                <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    inline
                    locale={'ru'}
                />
            </div>
        </div>
    );
};

export default SingleDate;